import React, { useState, useEffect, useCallback } from "react";
import { toast } from "../../../../components/toastNotification";
import TextInput from "../../../../components/TextInput";
import { useRecoilState } from "recoil";
import ConfirmBoxModal from "../../../../components/ConfirmBoxModal";
import OfficeBrandForm from "./OfficeBrandForm";
import AddButton from "../../../../components/AddButton";

import ConfirmBoxDelete from "../../../../components/ConfirmBoxDelete";
import MaterialExTable from "../../../../components/tables/MaterialExTable";

import Table from "../../../../components/tables/Table";

import useOfficeBrand from "./hooks/useOfficeBrand";
import useDeleteOfficeBrand from "./hooks/useDeleteOfficeBrand";
import useUpdateOfficeBrand from "./hooks/useUpdateOfficeBrand";
import {
  addStateOfficeBrand,
  selectedRowsStateOfficeBrand,
  setFilterTextOfficeBrand,
} from "./atoms/atoms";
import TableFilters from "../TableFilters";
import { accountAtom } from "../../../Login/atoms/AccountAtom";
import { PERMISSIONS } from "../../../PermissionsConstants";
import { useRecoilValue } from "recoil";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { getStates } from "../../../../actions/Utilities/Common";
import { useQuery, useQueryClient } from "react-query";
import SelectInput from "../../../../components/SelectInput";
import { notificationFilterById } from "../../../../actions/Utilities/NotificationFilter";
import { useHistory, useLocation } from "react-router-dom";
import SaveButton from "../../../../components/SaveButton";
import CancelButton from "../../../../components/CancelButton";
import EditButton from "../../../../components/EditButton";
import OfficeBrandExpandedRow from "./OfficeBrandExpandedRow";
import ShowButton from "../../../../components/ShowButton";
import HideButton from "../../../../components/HideButton";

const OfficeBrandTable = () => {
  //Hooks Call
  const { data, isFetching } = useOfficeBrand();
  const { mutateAsync: UpdateOfficeBrand } = useUpdateOfficeBrand();
  const BulkDeleteOfficeBrand = useDeleteOfficeBrand();
  //Atoms Call
  const [actionAddState, setActionAddState] =
    useRecoilState(addStateOfficeBrand);
  const [selectedRows, setSelectedRows] = useRecoilState(
    selectedRowsStateOfficeBrand
  );
  const [filterText, setFilterText] = useRecoilState(setFilterTextOfficeBrand);
  const userAccount = useRecoilState(accountAtom);
  //Local States
  const [rowsCount, setRowsCount] = useState(0);
  const [editRowId, setEditRowId] = useState(null);
  const [actionEditState, setActionEditState] = useState(false);
  const [empTypeIsExist, setEmpTypeIsExistState] = useState(false);
  const [empTypeDataIsChange, setEmpTypeDataIsChange] = useState(false);
  const [checkStatus, setCheckStatus] = useState(false);
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [openModalEdit, setOpenModalEdit] = useState(false);
  const [hasOfficeBrandName, setHasOfficeBrandName] = useState(true);
  const [isBulkSelected, setIsBulkSelected] = useState(false);
  const [disabledButton, setDisabledButton] = useState(false);
  const [hideColumn, sethideColumn] = useState(false);
  const [displayNote, setDisplayNote] = useState(false);
  const [edit, setEdit] = useState(false);
  const [states, setStates] = useState([]);
  const [showEdit, setShowEdit] = useState(false);
  const [show, setShow] = useState(false);
  const [selectedData] = useState();
  const [rowIsExpanded, setRowIsExpanded] = useState(false);
  const [expand, setExpand] = useState(false);
  const queryClient = useQueryClient();

  const [officeBrandFilteredData, setOfficeBrandFilteredData] = useState([]);

  const viewPermission =
    PERMISSIONS.permission_utilities_officeconfiguration_officebrand_view;
  const addPermission =
    PERMISSIONS.permission_utilities_officeconfiguration_officebrand_add;
  const editPermission =
    PERMISSIONS.permission_utilities_officeconfiguration_officebrand_edit;
  const deletePermission =
    PERMISSIONS.permission_utilities_officeconfiguration_officebrand_delete;

  const userPermissions = useRecoilValue(permissionsSelector);
  const defaultValues = {
    status: null,
    brandDescription: "",
    brandName: "",
    brandMarketingName: "",
    state: "",
    brandId: "",
  };
  const [empNewData, setNewData] = useState([defaultValues]);

  let location = useLocation();
  const history = useHistory();
  let recordIdFromRecent = "";
  if (location.state == null) {
    //Do nothing
  } else {
    recordIdFromRecent = location.state;
  }

  useEffect(() => {
    if (recordIdFromRecent) {
      try {
        notificationFilterById(
          recordIdFromRecent.recordId,
          recordIdFromRecent.moduleName,
          recordIdFromRecent.subModuleName
        ).then((result) => {
          setOfficeBrandFilteredData(result);
          setBrandId(recordIdFromRecent.recordId);
          history.replace();
        });
      } catch (error) {}
    } else {
      localStorage.removeItem("NotifFilter");
      localStorage.removeItem("ModuleFilter");
    }
  }, []);

  useEffect(() => {
    setEmpTypeIsExistState(false);
    setEmpTypeDataIsChange(false);
    setActionAddState(false);
    setActionEditState(false);
    setSelectedRows([]);
    setEditRowId([]);
  }, []);

  useQuery("States", getStates, {
    refetchOnWindowFocus: false,
    onSuccess: (res) => {
      setStates(
        res.map((data) => {
          return { value: data.stateId, label: data.state };
        })
      );
    },
  });

  const handleSelectedRowsChange = useCallback((state) => {
    setSelectedRows(state.selectedRows);
    setIsBulkSelected((prev) => !prev);
    setRowsCount(state.selectedRows.length);
  }, []);

  const handleCheckBox = (checked) => {
    setEmpTypeDataIsChange(true);
    checked ? setCheckStatus(true) : setCheckStatus(false);
    checked
      ? empNewData.map((x) => (x.status = 1))
      : empNewData.map((x) => (x.status = 0));
  };

  const handleEditFieldsChange = (SourceType, fieldName, row, inputvalue) => {
    inputvalue = inputvalue.trim();
    if (SourceType === "OfficeBrand") {
      empNewData.map((x) => (x[fieldName] = inputvalue));

      const result = data.filter(
        (item) =>
          item.brandName.toUpperCase() ===
            empNewData[0].brandName.toUpperCase() &&
          item.brandMarketingName.toUpperCase() ===
            empNewData[0].brandMarketingName.toUpperCase() &&
          item.state.toUpperCase() === empNewData[0].state.toUpperCase() &&
          item.brandDescription.toUpperCase() ===
            empNewData[0].brandDescription.toUpperCase()
      );

      if (result.length > 0 && result !== undefined) {
        setEmpTypeIsExistState(true);
        setEmpTypeDataIsChange(false);
      } else {
        setEmpTypeIsExistState(false);
        let reqFields = ["brandName", "brandMarketingName", "state"];
        if (
          reqFields.includes(fieldName) &&
          empNewData[0].brandName &&
          empNewData[0].brandMarketingName &&
          empNewData[0].state &&
          inputvalue !== ""
        ) {
          setEmpTypeDataIsChange(true);
        } else if (
          fieldName === "brandDescription" &&
          empNewData[0].brandName &&
          empNewData[0].brandMarketingName &&
          empNewData[0].state
        ) {
          setEmpTypeDataIsChange(true);
        } else {
          setEmpTypeDataIsChange(false);
        }
      }
    }
  };
  const colourStyles = {
    control: (styles) => ({ ...styles, backgroundColor: "white" }),
    option: (styles, { isDisabled }) => {
      return {
        ...styles,
        backgroundColor: isDisabled ? "red" : "green",
        color: "#FFF",
        cursor: isDisabled ? "not-allowed" : "default",
      };
    },
  };

  const handleEditButton = (rowData) => {
    setEditRowId(rowData.brandId);
    setEmpTypeDataIsChange(false);
    setEdit(true);
    setCheckStatus(rowData.status);
    empNewData.map((x) => (x.brandId = rowData.brandId));
    empNewData.map((x) => (x.status = rowData.status));
    empNewData.map((x) => (x.state = rowData.state));
    empNewData.map((x) => (x.brandName = rowData.brandName));
    empNewData.map((x) => (x.brandMarketingName = rowData.brandMarketingName));
    empNewData.map((x) => (x.brandDescription = rowData.brandDescription));
    empNewData.map((x) => (x.createdOn = rowData.createdOn));
    empNewData.map((x) => (x.createdBy = rowData.createdBy));
    empNewData.map((x) => (x.usedInMexico = rowData.usedInMexico));
    sethideColumn(false);
  };
  const ExpandRow = (rowData) => {
    //For multiple filtered records
    if (brandId?.includes(".")) {
      officeBrandFilteredData.map((item) => {
        if (item.brandId === rowData.brandId) item.expandRow = !item.expandRow;
        return { ...item };
      });
      setShow(!show);
    }
    //For single filtered record
    else if (officeBrandFilteredData?.length === 1) {
      officeBrandFilteredData.map((item) => {
        if (item.brandId === rowData.brandId) item.expandRow = !item.expandRow;
        return { ...item };
      });
      setShow(!show);
    }
    //For all record
    else {
      data.map((item) => {
        if (item.brandId === rowData.brandId) item.expandRow = !item.expandRow;
        return { ...item };
      });
      setShow(!show);
    }
  };
  //Save changes
  const handleSave = (empNewData) => {
    setOpenModalEdit(false);
    if (actionEditState) {
      UpdateOfficeBrand(empNewData, {
        onSuccess: (res) => {
          if (res === "Duplicate") {
            toast.fire("Failed", "The data already exists!", "error");
            setOpenModalEdit(false);
          } else {
            setNewData([defaultValues]);
            setEditRowId([]);
            setSelectedRows([]);
            setOpenModalEdit(false);
            setActionEditState(false);
            setDisabledButton(false);
            sethideColumn(false);
            setEdit(false);
            queryClient.invalidateQueries(["GetOfficeBrands"]);
            toast.fire(
              "Success",
              "Office Brand Updated Successfully",
              "success"
            );
          }
        },
        onError: () => {
          toast.fire("Failed", "Failed to Update Office Brand", "error");
          queryClient.invalidateQueries(["GetOfficeBrands"]);
          setOpenModalEdit(false);
        },
      });
    } else {
      toast.fire("Saving Failed", "No Changes have been made", "warning");
      setEditRowId([]);
      setOpenModalEdit(false);
      setEmpTypeDataIsChange(false);
      setActionEditState(false);
      setDisabledButton(false);
      setEdit(false);
    }
  };
  // end of saving changes

  const handleBulkDelete = () => {
    const ids = selectedRows.map((row) => row.brandId);
    BulkDeleteOfficeBrand(ids);
    setSelectedRows([]);
    setOpenModalDelete(false);
    setIsBulkSelected(false);
    setDisabledButton(false);
  };

  const deleteMessage = (
    <div className="text-gray-500 font-normal">{`Are you sure you want to deactivate ${rowsCount} ${
      rowsCount > 1 ? "Office Brands" : "Office Brand"
    }?`}</div>
  );

  const matColumns = [
    {
      name: "Brand Name",
      selector: "brandName",
      sortable: true,
      cell: (rowData) => {
        return rowData.brandId === editRowId ? (
          <div className="relative flex items-center w-full">
            <TextInput
              placeholder="Brand Name"
              defaultValue={rowData.brandName}
              required="true"
              onChange={(inputdata) => {
                handleEditFieldsChange(
                  "OfficeBrand",
                  "brandName",
                  rowData,
                  inputdata.target.value
                );
              }}
            />
          </div>
        ) : (
          <>{rowData.brandName}</>
        );
      },
    },
    {
      name: "Brand Description",
      selector: "brandDescription",
      sortable: true,
      cell: (rowData) => {
        return rowData.brandId === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer">
            <TextInput
              placeholder="Brand Description"
              defaultValue={rowData.brandDescription}
              onChange={(inputdata) => {
                handleEditFieldsChange(
                  "OfficeBrand",
                  "brandDescription",
                  rowData,
                  inputdata.target.value
                );
              }}
            />
          </div>
        ) : (
          <>{rowData.brandDescription}</>
        );
      },
    },
    {
      name: "Brand Marketing Name",
      selector: "brandMarketingName",
      sortable: true,
      cell: (rowData) => {
        return rowData.brandId === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer">
            <TextInput
              placeholder="Brand Marketing Name"
              defaultValue={rowData.brandMarketingName}
              onChange={(inputdata) => {
                handleEditFieldsChange(
                  "OfficeBrand",
                  "brandMarketingName",
                  rowData,
                  inputdata.target.value
                );
              }}
            />
          </div>
        ) : (
          <>{rowData.brandMarketingName}</>
        );
      },
    },
    {
      name: "State",
      selector: "state",
      sortable: true,
      cell: (rowData) => {
        return rowData.brandId === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer w-full">
            <SelectInput
              options={states}
              defaultValue={states.filter((x) => x.label === rowData.state)[0]}
              onChange={(selectedOptions) => {
                //setStates(selectedOptions);
                handleEditFieldsChange(
                  "OfficeBrand",
                  "state",
                  rowData,
                  selectedOptions === null ? "" : selectedOptions.label
                );
              }}
            />
          </div>
        ) : (
          <>{rowData.state}</>
        );
      },
    },
    {
      name: "Status",
      selector: "status",
      align: "center",
      sortable: true,
      cell: (rowData) => {
        return rowData.brandId === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer">
            <input
              type="checkbox"
              className="flex items-center space-x-1 cursor-pointer mt-1"
              defaultChecked={rowData.status}
              onClick={(e) => {
                handleCheckBox(e.target.checked);
              }}
            />
            <label className="cursor-pointer text-green-600" name="Status">
              {checkStatus ? "Uncheck to Deactivate" : "Check to Activate"}
            </label>
          </div>
        ) : (
          <div>
            <div className="font-sans text-left mr-4 text-xs">
              {rowData.status ? "Active" : "Inactive"}
            </div>
          </div>
        );
      },
    },

    {
      name: "Action/s",
      center: "true",
      cell: (rowData) => {
        return !userPermissions.includes(editPermission) ? (
          ""
        ) : rowData.brandId === editRowId ? (
          <div className="flex gap-2 sm:flex-col 1xl:flex-row justify-items-center">
            <SaveButton
              className={`flex shadow-md text-xs font-semibold text-white  gap-x-1 rounded-full  bg-senary hover:bg-senary px-3 py-1 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-senary focus:ring-opacity-70
            ${
              !hasOfficeBrandName || !empTypeDataIsChange
                ? "opacity-50"
                : "opactiy-100"
            }`}
              disabled={!hasOfficeBrandName || !empTypeDataIsChange}
              onClick={() => {
                setOpenModalEdit(true);
                sethideColumn(false);
              }}
            />
            <CancelButton
              className="flex shadow-md  text-xs  font-semibold text-white gap-x-1 rounded-full bg-octonary hover:bg-octonary px-3 py-1 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-octonary focus:ring-opacity-70"
              onClick={() => {
                setActionEditState(false);
                setEditRowId([]);
                setEmpTypeDataIsChange(false);
                setEmpTypeIsExistState(false);
                setDisabledButton(false);
                sethideColumn(false);
                setEdit(false);
              }}
            />
          </div>
        ) : (
          <div className="grid grid-col-1 justify-items-center">
            {rowData.expandRow ? (
              <HideButton
                className=""
                buttonText="Hide"
                isDisabled={(show, edit)}
                onClick={() => {
                  ExpandRow(rowData);
                }}
              />
            ) : (
              <div className="flex gap-2 sm:flex-col xl:flex-row justify-items-center">
                <ShowButton
                  buttonText="Show"
                  className={
                    (show || selectedRows.length > 0
                      ? "opacity-50 rounded-full space-x-2 items-center bg-quaternary hover:bg-tertiary text-white"
                      : edit
                      ? "opacity-50"
                      : "") + " border  text-white bg-quinary border-quinary  "
                  }
                  isDisabled={
                    show || selectedRows.length > 0 || edit ? true : false
                  }
                  onClick={() => {
                    ExpandRow(rowData);
                    //setShow(true);
                    setRowIsExpanded(true);
                  }}
                />
                {userPermissions.includes(editPermission) ? (
                  <EditButton
                    disabled={show || disabledButton || selectedRows.length > 0}
                    className={
                      show || disabledButton || selectedRows.length > 0
                        ? "opacity-50 text-white text-center text-sm bg-quaternary border-quaternary shadow-md h-5  lg:h-6 lg:px-1 w-16 lg:w-20   hover:border-hquaternary hover:bg-hquaternary hover:text-white flex flex-row items-center justify-center  border rounded-full transition duration-500 ease select-none focus:outline-none focus:shadow-outline "
                        : "opacity-100 text-white text-center text-sm bg-quaternary border-quaternary  shadow-md h-5  lg:h-6 lg:px-1 w-16 lg:w-20   hover:border-hquaternary hover:bg-hquaternary hover:text-white flex flex-row items-center justify-center  border rounded-full transition duration-500 ease select-none focus:outline-none focus:shadow-outline "
                    }
                    onClick={() => {
                      setDisabledButton(true);
                      setActionEditState(true);
                      handleEditButton(rowData);
                      sethideColumn(true);
                    }}
                  />
                ) : (
                  ""
                )}
              </div>
            )}
          </div>
        );
      },
    },
  ];

  //Filters
  const [brandId, setBrandId] = useState("");
  useEffect(() => {
    if (filterText) {
      setOfficeBrandFilteredData(
        data?.filter((x) =>
          x.brandName?.toLowerCase().includes(filterText.trim()?.toLowerCase())
        )
      );
    } else if (brandId?.includes(".")) {
      let brandIds = brandId.split(".");
      const brandIdsArr = brandIds.map((id) => Number(id));
      const filteredData = data?.filter((x) => brandIdsArr.includes(x.brandId));

      setOfficeBrandFilteredData(filteredData);
    } else {
      const filteredData = data?.filter((x) => x.brandId === Number(brandId));
      setOfficeBrandFilteredData(filteredData);
    }
  }, [filterText, data]);

  return (
    <div className="animate-fade-in-down w-full">
      {actionAddState ? (
        ""
      ) : (
        <div className="font-bold text-primary text-xl uppercase ">
          {" "}
          {/* <h1>Office Brand</h1>{" "} */}
        </div>
      )}
      {!actionAddState && (
        <>
          <div className="bg-white w-full p-4">
            <div className="flex flex-row justify-between items-center">
              <TableFilters
                filterText={setFilterText}
                moduleDetails="Brand Name"
                textInputName="brandName"
                disabledButton={disabledButton || selectedRows.length > 0}
              ></TableFilters>

              <div className="">
                {userPermissions.includes(addPermission) ? (
                  <AddButton
                    buttonText="New Office Brand"
                    className={
                      selectedRows.length > 0 || actionEditState
                        ? "opacity-50"
                        : "opacity-100"
                    }
                    onClick={() => setActionAddState(!actionAddState)}
                    disabled={disabledButton || selectedRows.length > 0}
                  />
                ) : (
                  ""
                )}
              </div>
            </div>
            <div>
              {userPermissions.includes(deletePermission) ? (
                <div className="text-secondary italic text-xs3 my-2">
                  <p className="font-bold italic inline-block mr-1">Note:</p>
                  <span>Tick the box to deactivate some data.</span>
                </div>
              ) : (
                <div className="mb-4"></div>
              )}
            </div>
            <div className="box-shadow rounded-r-md rounded-l-md">
              <Table
                isActive={false}
                columns={matColumns}
                data={
                  officeBrandFilteredData?.length > 0
                    ? officeBrandFilteredData
                    : data
                    ? filterText === ""
                      ? data
                      : data?.filter((x) =>
                          x.brandName
                            ?.toLowerCase()
                            .includes(filterText.trim()?.toLowerCase())
                        )
                    : []
                }
                options={{
                  toolbar: false,
                  showname: false,
                }}
                deletePermission={userPermissions.includes(deletePermission)}
                setOpenModal={setOpenModalDelete}
                onSelectedRowsChange={handleSelectedRowsChange}
                selectedRows={selectedRows}
                isDeactive={true}
                expandableRows
                expandableRowsComponent={(rowData) =>
                  show ? <OfficeBrandExpandedRow data={rowData.data} /> : ""
                }
                expandableRowExpanded={(rowData) => rowData.expandRow}
                isLoading={isFetching}
                selectableRowDisabled={(row) => !row.status}
                selectableRows={userPermissions.includes(deletePermission)}
              />
            </div>
          </div>

          <div className="space-y-5">
            <ConfirmBoxModal
              ModalTitle="Update Office Brand"
              qConfirmation=" Are you sure you want to update this?"
              isOpen={openModalEdit}
              onClose={() => {
                setOpenModalEdit(false);
                sethideColumn(true);
              }}
              onClickFunction={() => {
                handleSave(empNewData);
              }}
            />
            <ConfirmBoxDelete
              ModalTitle="Deactivate Office Brand"
              qConfirmation={deleteMessage}
              isOpen={openModalDelete}
              onClose={() => setOpenModalDelete(false)}
              onClickFunction={handleBulkDelete}
            />
          </div>
        </>
      )}
      {actionAddState && (
        <div className="px-4 py-2 mt-2">
          <OfficeBrandForm />
        </div>
      )}
      {/* </div> */}
    </div>
  );
};

export default OfficeBrandTable;
